/**
 * SupplierSelect.tsx - 供应商选择组件
 *
 * 功能说明：
 * - 供应商下拉选择
 * - 支持搜索过滤
 *
 * 依赖关系：
 * - 依赖 antd Select
 * - 依赖 services/supplierService.ts
 *
 * 关键注释索引：
 * - [供应商选项] - 见下方 optionFilterProp 配置
 *
 * 创建日期：2026-05-03
 * 作者：AI Assistant
 */

import React from 'react';
import { Select } from 'antd';

interface SupplierSelectProps {
  value?: string;
  onChange?: (value: string) => void;
  suppliersData?: any;
  disabled?: boolean;
  placeholder?: string;
}

/**
 * [供应商选择] 供应商下拉选择组件
 *
 * @description 支持：
 * - 显示供应商名称列表
 * - 搜索过滤
 * - 清除选择
 */
const SupplierSelect: React.FC<SupplierSelectProps> = ({
  value,
  onChange,
  suppliersData,
  disabled = false,
  placeholder = '请选择供应商',
}) => {
  const options = (suppliersData?.data || []).map((supplier: any) => ({
    value: supplier._id,
    label: supplier.name,
  }));

  return (
    <Select
      allowClear
      showSearch
      placeholder={placeholder}
      optionFilterProp="label"
      value={value}
      onChange={onChange}
      options={options}
      disabled={disabled}
      style={{ width: '100%' }}
    />
  );
};

export default SupplierSelect;
